import React from 'react'
import { ContentCP } from 'common/components/screen-layout/content/ContentCP'
import styled from 'config/theme/styledWithTheme'
import { LogoCP } from 'common/components/logo/LogoCP'

interface IContentAuthCPProps {
    children: JSX.Element
    maxWidthContainer?: number
}

/**
 * Componente para área de conteudo do login.
 *
 * @author renatofs
 */
export function ContentAuthCP(props: IContentAuthCPProps): JSX.Element | null {

    return (
        <ContentCP>
            <ContentWrapperSCP>
                <FormContainerSCP
                    maxWidth={props.maxWidthContainer}
                >
                    <LogoSCP>
                        <LogoCP
                            height={75}
                            marginBottom={25}
                            type={'logo'}
                        />
                    </LogoSCP>

                    {props.children}

                </FormContainerSCP>
            </ContentWrapperSCP>
        </ContentCP>
    )
}

const ContentWrapperSCP = styled.div`
    display: flex;
    justify-content: center;
    overflow: hidden auto;
    height: 100%;
    align-items: center;
    padding: 20px;

    .ant-layout {
	    background: #fff;
	}
`

const LogoSCP = styled.div`
    text-align: center;
`

const FormContainerSCP = styled.div<{ maxWidth?: number }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: ${props => props.maxWidth ?? 500}px;
`
